<app-page-header-png [isCurveGray]="true" header={{language.sitemappagename}} backgroundPath="assets/images/lead/default.png">
</app-page-header-png>

<div class="container">
    <div class="row">
        <div class="col-xl-12 col-md-12 col-sm-12 p-0 text-center mt-5">
            <ul class="p-0">
                <li>
                    <a herf="/home" class="header-home">
                        <i class="fas fa-home"></i>
                    </a>
                </li>
                <div class="page mt-5">
                    <div class="row">
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.menu1}}>
                                <button class="button--primary">
                                    <span>{{language.menu1}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/Favorite">{{language.favoritepagename}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/calendar">{{language.fmenu11}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/home">{{language.twoboxtitle1}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/download-form">{{language.downloadfromunitheader}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/fund-service-unit">{{language.sitemaplistext1}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.sitemapmenu2}}>
                                <button class="button--primary">
                                    <span>{{language.sitemapmenu2}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/fund">{{language.subtitlebox3}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/private-fund">{{language.fmenu7}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/provident-fund">{{language.fmenu9}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.sub4menu1}}>
                                <button class="button--primary">
                                    <span>{{language.sub4menu1}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/calculate">{{language.planinvestmentmenu2}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/calculate">{{language.planinvestmentmenu3}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.newsmenutab1}}>
                                <button class="button--primary">
                                    <span>{{language.newsmenutab1}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/th/News">{{language.newsmenutab1}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/th/Announcement">{{language.newsmenutab2}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/th/EarthUpdate">{{language.newsmenutab3}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/FundRecommend/option4">{{language.fundrecommmenutab4}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/FundRecommend/option1">{{language.sub4menu2}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/FundRecommend/option2">{{language.fundrecommmenutab2}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/FundRecommend/option3">{{language.fundrecommmenutab3}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/Promotion/promo">{{language.promotiontab1}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/Promotion/non-promo">{{language.promotiontab2}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.aboutusheader}}>
                                <button class="button--primary">
                                    <span>{{language.aboutusheader}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/about-us">{{language.aboutusmenu1}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/about-us">{{language.aboutusmenu2}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="/about-us">{{language.aboutusmenu3}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 pl-0">
                            <app-button text={{language.fmenu15}}>
                                <button class="button--primary">
                                    <span>{{language.fmenu15}}</span>
                                </button>
                            </app-button>
                            <ul class="mt-3 sub">
                                <li class="mt-2">
                                    <a href="/contact-us">{{language.fmenu15}}</a>
                                </li>
                                <li class="mt-2">
                                    <a href="https://www.facebook.com/OneAssetManagement/">FACEBOOK</a>
                                </li>
                                <li class="mt-2">
                                    <a href="http://line.me/ti/p/%40oil6565f">Line@</a>
                                </li>
                                <li class="mt-2">
                                    <a href="mailto:marketing@one-asset.com">E-mail</a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </ul>
        </div>
    </div>
</div>